<template>
  <span
    v-if="config.label"
    :class="['reading-flag-pill', config.class]"
    :title="legacyTooltip"
  >{{ config.label }}</span>
</template>

<script>
// Canonical Flag Mapping (spec §6) — owned by Honeycomb. Maps the QueenBee `ReadTypeFlag`
// enum to a pill label + CSS class. Colour is secondary to the visible text (accessibility);
// the §6 hex is applied via the scoped styles below. Vue 2.6 syntax only (no ?./??).
//
// Amendment A4: the pill renders QueenBee's `ReadTypeFlag` (via `value`); the legacy-derived
// industry value (MEX/COT/COS), supplied on the row as `_legacyFlagLabel`, is shown as the
// hover/alt (`title`) text so a user can see what the flag "used to" read.
const FLAG_CONFIG = {
  CoTStart: { label: 'CoT Start', class: 'cotReading' },
  CoTEnd: { label: 'CoT End', class: 'cotReading' },
  CoSStart: { label: 'CoS Start', class: 'cosReading' },
  CoSEnd: { label: 'CoS End', class: 'cosReading' },
  Installed: { label: 'Installed', class: 'mexReading' },
  Removed: { label: 'Removed', class: 'mexReading' },
}

export default {
  name: 'ReadingTypeFlagPill',

  props: {
    value: {
      type: String,
      default: null,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    config() {
      if (this.value === null || this.value === undefined || this.value === '') {
        return { label: '', class: '' }
      }
      const mapped = FLAG_CONFIG[this.value]
      if (mapped) return mapped
      // Forward-compatibility: an unknown enum member renders its raw value, no colour class.
      return { label: String(this.value), class: '' }
    },

    // A4: the legacy-calculated value (MEX/COT/COS) surfaced as the pill's alt/hover text.
    // Null when absent so no empty `title` attribute is rendered.
    legacyTooltip() {
      const legacy = this.row && this.row._legacyFlagLabel
      return legacy ? String(legacy) : null
    },
  },
}
</script>

<style scoped>
.reading-flag-pill {
  display: inline-block;
  padding: 0.2em 0.6em;
  font-size: 0.85em;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.75rem;
  border: 2px solid #495057;
  color: #000;
}

/* §6 canonical colours — scoped + !important to override the legacy global row classes. */
.reading-flag-pill.cotReading {
    background-color: #fce4ec !important;
}

.reading-flag-pill.cosReading {
    background-color: #e4ecfc !important;
}

.reading-flag-pill.mexReading {
    background-color: #ecfce4 !important;
}
</style>
